import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { NewInvitationActions } from './new-invitation.actions';
import { CreateNewInvitationStep } from './new-invitation.model';
import { NewInvitationState } from './new-invitation.state';

export const initState: NewInvitationState = {
  invitation: {
    gatewaySerial: '',
    note: '',
  },
  step: CreateNewInvitationStep.InvitationForm,
  creating: false,
  created: false,
  error: {},
};

/* eslint-disable */
export const newInvitationReducer: ActionReducer<NewInvitationState, Action> = createReducer(
  initState,
  on(NewInvitationActions.createInvitationInit, () => ({ ...initState })),
  on(NewInvitationActions.createInvitation, (state, { request }) => {
    const invitation: { gatewaySerial: string; note?: string } = {
      gatewaySerial: request.gatewaySerial,
    };
    if (request?.comment) {
      invitation.note = request.comment;
    }

    return { ...state, invitation, creating: true, error: {} };
  }),
  on(NewInvitationActions.createInvitationSuccess, (state) => ({
    ...state,
    step: CreateNewInvitationStep.InvitationCreated,
    creating: false,
    created: true,
    error: {},
  })),
  on(NewInvitationActions.createInvitationError, (state, { error }) => ({
    ...state,
    creating: false,
    created: false,
    error,
  }))
);
